<template>
  <v-dialog :value="value" max-width="800" @click:outside="close">
    <AuditTable :items="getTicketHistory" :loading="currentTicketLoading||ticketUpdateLoading">
      <template #title>Ticket Audit</template>
    </AuditTable>
  </v-dialog>
</template>

<script>
  import AuditTable from '@/components/Globals/AuditTable';
  import { mapState, mapGetters } from 'vuex';
  
  export default {
    components: { AuditTable },

    props: {
      value: {
        type: Boolean,
        default: false,
      },

      items: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      ...mapState('tickets', ['currentTicketLoading','ticketUpdateLoading']),
      ...mapGetters('tickets', ['getTicketHistory']),
    },

    methods: {
      close() {
        this.$emit('input', false);
      }
    },
  };
</script>

<style lang="scss" scoped>
</style>